export default __webpack_public_path__ + "static/media/ic_attendance.9a4e90b6.svg";